<dojo-empty-state [header]="params.text" [body]="params.body" [iconName]="params.icon" [iconColor]="params.iconColor" />
